import { useEffect } from 'react'

import { GUIDED_INTAKE_EVENTS } from '../../constants'
import { getGuidedIntakePageType } from '../../utils/getGuidedIntakePageType'
import { type GuidedIntakeEntryPointEnum } from '../../value-objects/enums'

export const useTrackGuidedIntakeEntryPointShown = (
  entryPoint: GuidedIntakeEntryPointEnum,
  isShown = true
) => {
  useEffect(() => {
    if (!isShown) return
    window.analytics?.track(GUIDED_INTAKE_EVENTS.ENTRY_POINT_SHOWN, {
      entry_point: entryPoint,
      page_type: getGuidedIntakePageType(),
    })
  }, [entryPoint, isShown])
}
